import { createAction } from '@reduxjs/toolkit';
import type {
  AiInstructionFilters,
  ContentSnippetFilters,
  IntentFilters,
} from 'api/types';
import type { WidgetInitMethod } from 'reducers/config';

export const configureAppActions = {
  ADD_RAW_PARAMS: 'add/rawParams',
  SET_AI_INSTRUCTIONS_FOR_PREVIEW: 'set/aiInstructionsForPreview',
  SET_API_KEY: 'set/apiKey',
  SET_CONTENT_SNIPPET_FILTERS_FOR_PREVIEW:
    'set/contentSnippetFiltersForPreview',
  SET_INTENT_FILTERS_FOR_PREVIEW: 'set/setIntentFiltersForPreview',
  SET_ORIGIN: 'set/origin',
  SET_PREVIEW_IS_LIVE_MODE: 'set/previewIsLiveMode',
  SET_RAW_PARAMS: 'set/rawParams',
  SET_WIDGET_INIT_METHOD: 'set/widgetInitMethod',
} as const;

const setAPIKey = createAction<string>(configureAppActions.SET_API_KEY);
const setIntentFiltersForPreview = createAction<IntentFilters>(
  configureAppActions.SET_INTENT_FILTERS_FOR_PREVIEW,
);
const setPreviewIsLiveMode = createAction<boolean>(
  configureAppActions.SET_PREVIEW_IS_LIVE_MODE,
);
const setAiInstructionsForPreview = createAction<AiInstructionFilters[]>(
  configureAppActions.SET_AI_INSTRUCTIONS_FOR_PREVIEW,
);
const setContentSnippetFiltersForPreview = createAction<
  ContentSnippetFilters[]
>(configureAppActions.SET_CONTENT_SNIPPET_FILTERS_FOR_PREVIEW);
const setOrigin = createAction<string>(configureAppActions.SET_ORIGIN);
const addRawParams = createAction<{ [attrName: string]: string | boolean }>(
  configureAppActions.ADD_RAW_PARAMS,
);
const setRawParams = createAction<{
  [attrName: string]: string | boolean;
}>(configureAppActions.SET_RAW_PARAMS);
const setWidgetInitMethod = createAction<WidgetInitMethod>(
  configureAppActions.SET_WIDGET_INIT_METHOD,
);

export {
  setAPIKey,
  setOrigin,
  addRawParams,
  setRawParams,
  setIntentFiltersForPreview,
  setPreviewIsLiveMode,
  setWidgetInitMethod,
  setAiInstructionsForPreview,
  setContentSnippetFiltersForPreview,
};
